import curry from "../lib/core/functional/curry";

export const replacePreactWithProps = curry((renderer, Module, element, props, replaceNode) => {
    element.classList.add("loaded", "rm-preact");
    const rendered = renderer.preact.h(Module, props);
    return renderer.preact.render(rendered, element, replaceNode);
});

export default curry(function renderPreactWithProps(renderer, Module, element, props) {
    return replacePreactWithProps(renderer, Module, element, props, null);
});
